export const getOrder = (order, id) => {
  if (order.column === id) {
    const ascending =
      order.ascending === null ? false : order.ascending === false ? true : null

    return {
      column: order.ascending === true ? null : order.column,
      ascending,
    }
  }

  return {
    column: id,
    ascending: false,
  }
}

export const filterAndOrder = (data, order, searchBy, searchByKeys) => {
  const filtered = data.filter(
    row =>
      !searchBy ||
      searchByKeys.some(searchByKey =>
        row[searchByKey].toLowerCase().includes(searchBy.toLowerCase()),
      ),
  )

  if (order.column === null && order.ascending === null) {
    return filtered
  }

  const ordered = [...filtered].sort((rowA, rowB) =>
    rowA[order.column].localeCompare(rowB[order.column]),
  )

  return order.ascending ? ordered : ordered.reverse()
}
